import { render } from "./UsersBody.vue?vue&type=template&id=668f7f62"
import script from "./UsersBody.vue?vue&type=script&lang=js"
export * from "./UsersBody.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__